import { FC, memo } from "react"
import { useTranslation } from "react-i18next"
import { rarityStyle } from "@/helpers/rarity"
import { CurrencyIcon } from "@/ui/CurrencyIcon"
import styles from "./MobLootGrid.module.scss"
import { IMobLootGridProps } from "./types"

const MobLootGridComponent: FC<IMobLootGridProps> = ({ tiles }) => {
  const { t } = useTranslation(["inventory", "catalog"])

  return (
    <ul className={styles.MobLootGrid}>
      {tiles.map((tile) =>
        tile.kind === "currency" ? (
          <li
            key={`currency:${tile.currencyCode}`}
            className={styles.MobLootGrid_tile}
          >
            <CurrencyIcon
              size="fill"
              iconUrl={tile.iconUrl}
              alt={t(`currency.${tile.currencyCode}.name`, { ns: "catalog" })}
            />
            <span className={styles.MobLootGrid_quantity}>
              {tile.rangeText}
            </span>
          </li>
        ) : (
          <li
            key={`${tile.itemCode}:${tile.rarityCode}`}
            className={styles.MobLootGrid_tile}
            style={rarityStyle({
              rarityCode: tile.rarityCode,
              hasRarityDimension: true
            })}
          >
            {tile.iconUrl ? (
              <img
                className={styles.MobLootGrid_icon}
                src={tile.iconUrl}
                alt={t(`item.${tile.itemCode}.name`, { ns: "inventory" })}
                loading="lazy"
                decoding="async"
              />
            ) : (
              <span className={styles.MobLootGrid_name}>
                {t(`item.${tile.itemCode}.name`, { ns: "inventory" })}
              </span>
            )}
            <span className={styles.MobLootGrid_quantity}>
              {tile.quantityText}
            </span>
          </li>
        )
      )}
    </ul>
  )
}

export const MobLootGrid = memo(MobLootGridComponent)
